import { FixCat } from "../fixcat/fixcat";
import { Machine } from "../machine/machine";

export class DispatchItem {
    id: number;
    fixcats: FixCat[];
    dispatchorder: number;
    machine: Machine;
    details: String;
    ticket: String;
}

